import React from 'react';

import Typography from 'components/typography/typography';

interface cardHeaderPropTypes {
  title?: string;
}

const CardHeader: React.FC<cardHeaderPropTypes> = (props) => {
  const { title } = props;

  return (
    <div className="w-full flex justify-between items-center h-fit my-3 bg-transparent hover:bg-gray75 mx-0 px-4">
      <Typography as="h2" variant="body-large-bold" className="text-gray900">
        {title || ''}
      </Typography>
    </div>
  );
};

export default CardHeader;
